export const SITE_NAME = "Signal Technologies";
export const ADDRESS = "51 rue des trois visages 62000 Arras - Email: contact@signal-technologies.info";